import adresseGenerer from '@/services/general/genererAdresse';
import genererSignataire from '@/services/general/generer/genererSignataire';

export default function genererAgence() {
  return {
    codeAgence: null,
    libelle: null,
    emailPrincipal: null,
    telephone: null,
    fax: null,
    adresse: adresseGenerer(),
    signataire: genererSignataire(),
    prefixeCodeFacture: null,
    codeMetier: null,
    codeSite: null,
    domiciliationBancaireId: null,
    piedPageHtml: null,
    regimeTvaId: null,
  };
}
